import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import {
  onAuthStateChanged,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
} from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null); // 'admin', 'client', 'lead'

  const adminEmail = 'ruben.oreamuno2000@gmail.com'; // Updated admin email here

  // Function to get or create user profile in Firestore
  const getUserProfile = async (user) => {
    if (!user) return null;

    const userRef = doc(db, 'users', user.uid);
    const docSnap = await getDoc(userRef);

    if (docSnap.exists()) {
      const profile = docSnap.data();
      setUserRole(profile.role);
      return profile;
    } else {
      // New user, create profile as 'lead'
      const newProfile = {
        uid: user.uid,
        email: user.email,
        name: user.displayName || user.email,
        role: user.email === adminEmail ? 'admin' : 'lead', // Assign admin role if email matches
        createdAt: new Date(),
      };
      await setDoc(userRef, newProfile);
      setUserRole(newProfile.role);
      return newProfile;
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      if (user) {
        await getUserProfile(user);
      } else {
        setUserRole(null);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const loginWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error("Error logging in with Google:", error);
      throw error;
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
      setCurrentUser(null);
      setUserRole(null);
    } catch (error) {
      console.error("Error logging out:", error);
      throw error;
    }
  };

  const value = {
    currentUser,
    userRole,
    loading,
    loginWithGoogle,
    logout,
    adminEmail,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
